var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgURL)?_c('v-img',{attrs:{"src":_vm.imgURL}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }